import type { IdempotencyKey } from "@whitehaven/contracts";

export function createSchedulingIdempotencyKey(): IdempotencyKey | null {
  try {
    const value = globalThis.crypto?.randomUUID?.();
    return value && /^[A-Za-z0-9_-]{8,128}$/.test(value)
      ? (value as IdempotencyKey)
      : null;
  } catch {
    return null;
  }
}
